<template>
  <div class="box">
    <vxe-table border :show-header="false" :data="tableData">
      <vxe-column
        align="center"
        width="150px"
        field="title"
        title="title"
      ></vxe-column>
      <vxe-column title="option">
        <template #default="{ row }">
          <ul class="select" v-if="row.title == '配件类型'">
            <li
              v-for="item in row.option"
              :key="item.id"
              @click="checkedEvent(row.title, item.id)"
              :class="item.id == checkedType ? 'checked' : ''"
            >
              {{ item.name }}
            </li>
          </ul>
          <ul class="select" v-else>
            <li
              v-for="item in row.option"
              :key="item.carBrandId"
              @click="checkedEvent(row.title, item)"
              :class="item == checkedBrand ? 'checked' : ''"
            >
              {{ item }}
            </li>
          </ul>
        </template>
      </vxe-column>
    </vxe-table>
  </div>
</template>

<script>
import { getListPartsType } from '../../api/goodsList.js'
export default {
  props: {
    obj: Object
    // brandArr: Array
  },
  data() {
    return {
      checkedType: -1,
      checkedBrand: '不限',
      tableData: [
        {
          title: '配件类型',
          option: []
        },
        {
          title: '配件品牌',
          option: [
            '不限',
            '博世',
            '马勒',
            '法雷奥',
            '采埃孚',
            '科德宝',
            '斯凯孚',
            '曼牌',
            '猫头鹰',
            '博世',
            '博世',
            '马勒',
            '法雷奥',
            '采埃孚',
            '科德宝',
            '斯凯孚',
            '曼牌',
            '猫头鹰',
            '博世',
            '博世',
            '马勒',
            '法雷奥',
            '采埃孚',
            '科德宝',
            '斯凯孚',
            '曼牌',
            '猫头鹰',
            '博世',
            '马勒',
            '法雷奥',
            '采埃孚',
            '科德宝',
            '斯凯孚',
            '曼牌',
            '猫头鹰',
            '博世',
            '勒  ',
            '法雷奥',
            '采埃孚 '
          ]
        }
      ]
    }
  },
  created() {
    // this.getListPartsType()
  },
  methods: {
    checkedEvent(title, index) {
      console.log(title, index)
      console.log(this.tableData[1].option)
      if (title == '配件类型') {
        this.checkedType = index
        this.checkedBrand = '不限'
      } else {
        this.checkedBrand = index
      }
      console.log(this.checkedType, this.checkedBrand)
      // this.checkedType = this.checkedType == -1 ? '' : this.checkedType
      // this.checkedBrand = this.checkedBrand == -1 ? '' : this.checkedBrand - 0
      let type1 = this.checkedType == -1 ? '' : this.checkedType
      let type2 = this.checkedBrand == '不限' ? '' : this.checkedBrand
      this.$parent.changeType(type1, type2)
    },
    // 获取配件类型
    async getListPartsType(PartsTypeArr, partType) {
      console.log(PartsTypeArr, partType);
      // if (this.obj) {
      //   console.log(this.obj)
      //   if (Object.values(this.obj).some((i) => i === undefined)) {
      //     this.checkedType = -1
      //     this.checkedBrand = -1
      //   } else {
      //     this.checkedType = this.obj.o
      //     this.checkedBrand = this.obj.b
      //   }

      //   console.log('6666666666')
      // } else {
      //   this.checkedType = -1
      //   this.checkedBrand = -1
      //   console.log('8888888888')
      // }
      // console.log(this.checkedType, this.checkedBrand)
      // let res = await getListPartsType()
      // console.log(res)
      this.tableData[0].option = [{"id": "0", "name": "品牌件"},{"id": "1", "name": "原厂件"},]
      this.tableData[0].option.unshift({ id: '-1', name: '不限' })
      // this.checkedType = '-1'
      if (partType) {
        this.checkedType = partType
      }
      console.log(this.checkedType)
    },
    // 获取配件品牌
    getListBrandType(brandArr, brandId) {
      console.log(brandArr, brandId);
      // this.$nextTick(() => {
      this.tableData[1].option = brandArr
      this.tableData[1].option.unshift('不限')
      // this.checkedBrand = '-1'
      if (brandId) {
        this.checkedBrand = brandId
      }
      console.log(this.checkedBrand)

      // })
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  background-color: antiquewhite;
  margin-top: 10px;
  /deep/ .vxe-cell {
    .vxe-cell--label {
      font-weight: 700;
    }
  }
}
/deep/.vxe-table--render-default .vxe-cell {
  max-height: 70px;
  overflow: auto;
  white-space: inherit;
}
/deep/.vxe-body--row {
  td:first-of-type {
    height: 50px;
    background: #f6f6f6;
    border-bottom: 1px solid #e2e2e2;
    border-right: 1px solid #e2e2e2;
  }
  .vxe-cell {
    padding: 0;
  }
}

.select {
  display: flex;
  justify-content: left;
  flex-wrap: wrap;

  li {
    // display: inline;
    cursor: pointer;
    margin: 5px 5px;
    padding: 1px 8px;
    height: 24px;
    // padding: 5px 9px;
    // height: 33px;
    opacity: 1;
    border-radius: 2px;
    // text-align: center;
    color: #377cf1;
    &:hover {
      background-color: #377cf1;
      color: #fff;
      // font-weight: 700;
      // color: #2871f1;
    }
  }
  // 选中
  .checked {
    color: #fff;
    background-color: #377cf1;
    white-space: inherit;
    &:hover {
      color: #fff;
    }
  }
}
</style>
